/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { ProductsAutoBulkImportContext } from '../contexts/ProductsAutoBulkImportContext';
import 'react-csv-importer/dist/index.css';
import Breadcrumbs from '../../../modules/navigation/components/Breadcrumbs';
import ProductAutoBulkcsvImport from '../components/ProductsAutoBulkcsvImport';

const ProductsAutoBulkcsvImportPage: React.FunctionComponent = () => {
  const history = useHistory();
  const { machineSerial } = useParams<Record<string, string>>();

  const { setFailedRecords, setPassedRecords } = React.useContext(ProductsAutoBulkImportContext);

  React.useEffect(() => {
    setFailedRecords([]);
    setPassedRecords([]);
  }, []);

  const links = [
    {
      onClick: () => history.push(`/autobulk/machines/products`),
      text: 'AutoBulk Products',
    },
    {
      onClick: () => null,
      text: `Bulk Import (Machine: ${machineSerial})`,
    },
  ];

  return (
    <>
      <Grid justifyContent="space-between" container spacing={3}>
        <Grid item>
          <Breadcrumbs links={links} />
        </Grid>
      </Grid>
      <br />
      <ProductAutoBulkcsvImport machineSerialNumber={machineSerial} />
    </>
  );
};

export default ProductsAutoBulkcsvImportPage;
